export default __webpack_public_path__ + "static/contact-dec-26cd40a14d7fa6d0de5c43e98814757c.png";